export const HTTPURL = "https://api.liftracka.kindlebit.com/";
export const PUBLISH_KEY='pk_test_51Q4kIAKnD7EYZIxKD4w3Aaulj9QDJba8gJsLOKPkn1fTY9r6DfU7zztWNAs0rk9S0lNLrx8Ulo2Y9lacIsmG4hLr00yz0gNrPT'
